import axios from 'axios';
import {} from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({
    nlpPosts: {}
});

export const getters = {
    nlpPosts: state => state.nlpPosts
};

export const mutations = {
    SET_NLP_POSTS(state, { id, nlpPosts }) {
        state.nlpPosts[id] = nlpPosts;
    }
};

export const actions = {
    async index(
        vuexContext,
        {
            contextId,
            limit,
            range,
            comparedRange,
            accountId,
            timeZone,
            properties,
            sort,
            order,
            search,
            ...additionalParams
        }
    ) {
        const params = {
            ...additionalParams,
            range,
            comparedRange: comparedRange,
            limit,
            timeZone,
            accountId,
            sort,
            order,

            keyword: search,
            properties: toSnakeCaseThenStringify(properties)
        };
        let path = '/v1/dashboard/conversation_themes';

        let res = await axios.getMethodOverridePost(path, { params, encodeURI: true });
        vuexContext.commit('SET_NLP_POSTS', { id: contextId, nlpPosts: res.nlpAnalyzedCount });
        return res;
    },

    csv(vuexContext, { limit, range, comparedRange, accountId, timeZone, properties, sort, order }) {
        const params = {
            range,
            comparedRange: comparedRange,
            limit,
            timeZone,
            accountId,
            sort,
            order,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePostWithHeaders('/v1/dashboard/conversation_themes.csv', {
            params,
            encodeURI: true
        });
    }
};
